<template>
    <div v-loading="loading">
        <div class="invoice_box" v-if="show == false">
            <div class="hidden_y">
                <el-button @click="back" slot="tt_r" type="primary" class="butn">返回</el-button>
                <span>订单号: {{orderid}}</span>
            </div>
            <div class="invoice_list">
                <el-form
                        label-width="150px"
                        ref="manageAuthInfo"
                        :rules="companyAuthInfo_rules"
                        :model="manageAuthInfo"
                        class="invoice_div"
                >
                    <el-form-item label="发票类型" class="fa_piao" prop="type" >
                        <el-select v-model="manageAuthInfo.type" placeholder="请选择">
                            <el-option label="增值税专用发票(纸质)" :value="0" v-if="orderAmount>1000"></el-option>
                            <el-option label="普通发票(电子)" :value="1" v-if="orderAmount<1000"></el-option>
                            <el-option label="普通发票(纸质)" :value="2" v-if="orderAmount>1000"></el-option>
                        </el-select>
                        <span class="ti_shi">发票说明？
                        <p class="test_ti_shi">
                            1、开票内容为“服务费”；<br>
                            2、满1000元可申请增值税专用发票，免邮费；<br>
                            3、增值税专用发票在七个工作日内发出；
                        </p>
                        </span>

                    </el-form-item>
                    <el-form-item label="发票抬头" prop="title">
                        <el-input v-model="manageAuthInfo.title" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" prop="realFitting">
                        <el-input v-model="manageAuthInfo.realFitting" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱" prop="receiverEmil" v-show="manageAuthInfo.type == 1">
                        <el-input v-model="manageAuthInfo.receiverEmil" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="对公账户开户银行" :prop="manageAuthInfo.type == 0?'corporateCredit':''" v-show="manageAuthInfo.type == 0 || manageAuthInfo.type == 2">
                        <el-input v-model="manageAuthInfo.corporateCredit" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="对公账号" :prop="manageAuthInfo.type == 0?'corporateAccount':''" v-show="manageAuthInfo.type == 0 || manageAuthInfo.type == 2">
                        <el-input v-model="manageAuthInfo.corporateAccount" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="公司电话" :prop="manageAuthInfo.type == 0?'phone':''">
                        <el-input v-model="manageAuthInfo.phone"  maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="公司地址" :prop="manageAuthInfo.type == 0?'address':''">
                        <el-input v-model="manageAuthInfo.address" maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行" v-show="manageAuthInfo.type == 1">
                        <el-input v-model="manageAuthInfo.corporateCredit" maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账号" v-show="manageAuthInfo.type == 1">
                        <el-input v-model="manageAuthInfo.corporateAccount" maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" class="item_from" prop="remark">
                        <el-input v-model="manageAuthInfo.remark" type="textarea" :rows="4" maxlength="150"></el-input>
                    </el-form-item>
                    <el-divider v-if="manageAuthInfo.type == 0 || manageAuthInfo.type == 2"> 收件信息</el-divider>
                    <el-form-item label="收件人" prop="receiverName" v-show="manageAuthInfo.type == 0 || manageAuthInfo.type == 2">
                        <el-input v-model="manageAuthInfo.receiverName" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="收件人手机号" prop="receiverPhone" v-show="manageAuthInfo.type == 0 || manageAuthInfo.type == 2">
                        <el-input v-model="manageAuthInfo.receiverPhone" maxlength="11" ></el-input>
                    </el-form-item>
                    <el-form-item label="所在地区" prop="city_value" class="di_qu" v-show="manageAuthInfo.type == 0 || manageAuthInfo.type == 2">
                        <el-select v-model="province_value" filterable value-key="id" placeholder="请选择"
                                   @change="met_province">
                            <el-option
                                    v-for="item in province"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="city_value" filterable value-key="id" placeholder="请选择" @change="met_city">
                            <el-option
                                    v-for="item in city"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="area_value" filterable value-key="id" placeholder="请选择" @change="met_area">
                            <el-option
                                    v-for="item in area"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="receiverAddress_s" v-show="manageAuthInfo.type == 0 || manageAuthInfo.type == 2">
                        <el-input v-model="manageAuthInfo.receiverAddress_s" maxlength="40"></el-input>
                    </el-form-item>
                    <div class="invoice_bottom">
                        <el-button class="submit_butn" type="primary" @click="prev_butn">提交申请</el-button>
                    </div>
                </el-form>
            </div>

        </div>
        <div class="invoice_box submit_succeed" v-if="show == true">

            <img src="@/assets/img/fb.png" alt/>
            <div>发票申请成功，将在1～3个工作日受理！</div>
            <el-button class="el_bo" @click="back"> 返回订单</el-button>
        </div>

    </div>

</template>

<script>
    import {receiverEmil ,validatePhone ,validatePhoneTwo} from '@/plugins/checkForm'
    export default {
        name: "apply_for_invoice",
        data() {
            return {
                loading: false,
                show: false,
                value: '',
                orderAmount:this.$route.params.orderAmount,
                manageAuthInfo: {
                    type: this.$route.params.orderAmount>1000?0:1,
                    codeList: []
                },
                companyAuthInfo_rules: {
                    type: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    title: [
                        {required: true, message: "请输入发票抬头", trigger: "blur"}
                    ],
                    realFitting: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    receiverEmil: [
                        {required: true, message: " ", trigger: "blur"},
                        { validator:receiverEmil}
                    ],
                    corporateCredit: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    corporateAccount: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    phone: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    address: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    receiverName: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    receiverPhone: [
                        {required: true, message: " ", trigger: "blur"},
                        { validator:validatePhone}
                    ],
                    city_value: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                    receiverAddress_s: [
                        {required: true, message: " ", trigger: "blur"}
                    ],
                },
                orderid: this.$route.params.id,
                province: {},
                city: {},
                area: {},
                province_value: '',
                city_value: '',
                area_value: '',
                province_name: '',
                city_name: '',
                area_name: '',

            }
        },
        mounted() {
            this.get_province()
        },
        methods: {
            back() {
                this.$router.go(-1); //返回上一层
            },

            prev_butn() {
                if(this.manageAuthInfo.type == 0){

                    if(!this.manageAuthInfo.title || !this.manageAuthInfo.realFitting || !this.manageAuthInfo.corporateCredit || !this.manageAuthInfo.corporateAccount || !this.manageAuthInfo.phone || !this.manageAuthInfo.address || !this.manageAuthInfo.receiverName || !this.manageAuthInfo.receiverPhone || !this.province_value ||  !this.manageAuthInfo.receiverAddress_s ){
                        this.$message({
                            message: '必填信息不能为空',
                            type: 'warning'
                        });
                        return
                    }
                }else if(this.manageAuthInfo.type == 1){
                    if(!this.manageAuthInfo.title || !this.manageAuthInfo.realFitting || !this.manageAuthInfo.receiverEmil  ){
                        this.$message({
                            message: '必填信息不能为空',
                            type: 'warning'
                        });
                        return
                    }
                }else {
                    if(!this.manageAuthInfo.title || !this.manageAuthInfo.realFitting  || !this.manageAuthInfo.receiverName || !this.manageAuthInfo.receiverPhone || !this.province_value ||  !this.manageAuthInfo.receiverAddress_s ){
                        this.$message({
                            message: '必填信息不能为空',
                            type: 'warning'
                        });
                        return
                    }
                }
                this.manageAuthInfo.codeList =[];
                this.manageAuthInfo.codeList.push(this.$route.params.orderCode)
                this.manageAuthInfo.receiverAddress = ''
                this.manageAuthInfo.receiverAddress = this.province_name + '-' + this.city_name + '-' + this.area_name + ' ' + this.manageAuthInfo.receiverAddress_s
                if(!this.manageAuthInfo.receiverAddress_s){
                    this.manageAuthInfo.receiverAddress = ''
                }
                this.$confirm('确认申请发票信息,此操作只有一次,请谨慎操作.', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.$SIF.httpPost({
                        url: this.$SIF._serve.order + "/functron/add/Invoice",
                        data: this.manageAuthInfo,
                        succFun: res => {
                            this.loading = false
                            if (res.code == 10000) {
                                this.show = true
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'warning'
                                });
                            }
                        },
                        failFun: res => {
                            this.loading = false
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    });
                });

            },
            get_province() {
                this.loading = true
                this.$SIF.httpPost({
                    url: this.$SIF._serve.order + "/functron/query/queryRegion",
                    data: {},
                    succFun: res => {
                        this.province = res.data
                        this.loading = false
                    },
                    failFun: res => {
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            met_province(selVal) {
                this.get_city(selVal.id)
                this.province_name = selVal.name
                this.city_name = ''
                this.area_name = ''
                this.city_value = '';
                this.area_value = '';

            },
            met_city(selVal) {
                this.get_area(selVal.id)
                this.area_value = '';
                this.city_name = selVal.name
                this.area_name = ''

            },
            met_area(selVal) {
                this.area_name = selVal.name
            },
            get_city(id) {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.order + "/functron/query/queryRegion",
                    data: {id: id},
                    succFun: res => {
                        this.city = res.data
                    },
                    failFun: res => {

                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_area(id) {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.order + "/functron/query/queryRegion",
                    data: {id: id},
                    succFun: res => {
                        this.area = res.data
                    },
                    failFun: res => {

                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
        }
    }
</script>

<style scoped type="text/css">
    .invoice_box {
        width: 100%;
        background: #ffffff;
        height: 100%;
        position: relative;
    }

    .invoice_div {
        padding: 15px 0;
        width: 50%;
        margin: 0 auto;
    }

    .ti_shi {
        margin-left: 15px;
        color: #FF4B20;
        font-size: 12px;
        cursor: pointer;
    }

    .test_ti_shi {
        background: rgba(15, 15, 15, 0.6);
        border-radius: 10px;
        color: #FFFFFF;
        padding: 10px 5px;
        position: absolute;
        top: -9px;
        right: -257px;
        /*display: none;*/
        line-height: 23px;
    }

    .ti_shi:hover .test_ti_shi {
        display: block;
    }


    .invoice_div .el-input, .invoice_div .el-textarea {
        width: 80%;
    }

    .di_qu .el-select {
        width: 28%;
    }

    .fa_piao .el-select {
        width: 80%;
    }
    .el-select-dropdown__item:hover{
        background:  rgba(49,202,132,0.2);
        color: #0DA15D;
    }

    .di_qu >>> .el-input {
        width: 85%;
    }

    .invoice_list {
        width: 100%;
        height: -webkit-calc(100% - 40px);
        height: -moz-calc(100% - 40px);
        height: calc(100% - 40px);
        overflow-x: hidden;
        overflow-y: auto;
    }

    .invoice_list::-webkit-scrollbar {
        width: 4px;
        /*height: 4px;*/
    }

    .invoice_bottom {
        width: 100%;
        text-align: center;
    }

    .invoice_list::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .invoice_list::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }

    .hidden_y {
        width: 100%;
        height: 40px;
        background: rgba(251, 251, 251, 1);
        border-radius: 5px 5px 0px 0px;
        line-height: 40px;
    }

    .hidden_y span {
        color: #0FC87D;
        font-size: 14px;
    }

    .butn {
        margin-left: 20px;
        height: 26px;
        padding: 5px 10px;
        margin-right: 30px;
    }

    .child {
        height: 100%;
    }

    .submit_succeed {
        padding-top: 150px;
        text-align: center;
    }

    .submit_succeed img {
        width: 70px;
        margin-bottom: 20px;
    }

    .submit_succeed {
        color: #1CA868;
        font-size: 18px;
    }

    .el_bo {
        width: 117px;
        height: 33px;
        background: rgba(49, 202, 132, 1);
        border-radius: 8px;
        color: #ffffff;
        margin-top: 30px;
        border: 0;
        padding: 0;
    }
</style>